export type SelectableRepository = { id: number; selected: boolean };

export function getEffectiveRepositoryIds(
  repositories: SelectableRepository[],
  selectedIds: number[] | null,
) {
  if (selectedIds !== null) {
    return selectedIds;
  }

  return repositories
    .filter((repository) => repository.selected)
    .map((repository) => repository.id);
}

export function hasRepositorySelectionChanged(
  repositories: SelectableRepository[],
  selectedIds: number[] | null,
) {
  if (selectedIds === null) {
    return false;
  }

  const persistedIds = new Set(
    repositories
      .filter((repository) => repository.selected)
      .map((repository) => repository.id),
  );
  const draftIds = new Set(selectedIds);

  if (persistedIds.size !== draftIds.size) {
    return true;
  }

  return [...draftIds].some((repositoryId) => !persistedIds.has(repositoryId));
}
